var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarrantyS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.55566L6 0.555664L12 2.55566V9.41466C12 10.7527 11.332 12.0017 10.219 12.7427L6 15.5557L1.781 12.7427C0.668 12.0007 0 10.7517 0 9.41466V2.55566ZM1.5 7.55566V9.41466C1.5 10.2503 1.91752 11.0309 2.61305 11.4946L6 13.7528L6 7.55566H10.5V3.6368L6 2.1368V7.55566H1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyS);
export default __webpack_public_path__ + "static/media/warranty-S.2afd692cfdc8f5109f7018ea48dac036.svg";
export { ForwardRef as ReactComponent };